import { CustomModal, EventEmitterWithIndex } from '@nile/components';
import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import ServiceCatalogForm from './ServiceCatalogForm';
import { UserGuide } from '@nile/client_management/src/Contracts/Components/UserGuidePopup';

type ServiceCatalogOptionsType = 'PRODUCT' | 'SERVICE' | 'PACKAGE';

const ServiceCatalogModal = ({
  reference,
  saveServiceCatalogItem,
  className,
  hideAddNew
}) => {
  const [showForm, setShowForm] = useState<boolean>(false);

  const serviceCatalogFormDataRef = useRef<{
    mode: 'NEW' | 'EDIT' | 'CLONE';
    selectedCatologType?: ServiceCatalogOptionsType | null;
    serviceCatalogItemId?: string | null;
  }>({ mode: 'NEW', selectedCatologType: 'SERVICE' });

  function showServiceCatalogForm({
    mode,
    catalogType,
    catalogItemId
  }: {
    mode: 'NEW' | 'EDIT' | 'CLONE';
    catalogType?: ServiceCatalogOptionsType;
    catalogItemId?: string;
  }) {
    serviceCatalogFormDataRef.current = {
      mode: mode
    };
    if (catalogItemId)
      serviceCatalogFormDataRef.current.serviceCatalogItemId = catalogItemId;
    if (catalogType)
      serviceCatalogFormDataRef.current.selectedCatologType =
        catalogType || 'SERVICE';
    setShowForm(true);
  }

  function hideServiceCatalogFormForm() {
    serviceCatalogFormDataRef.current = {
      mode: 'NEW',
      selectedCatologType: null
    };
    setShowForm(false);
  }

  useImperativeHandle(reference, () => {
    return {
      showForm: showServiceCatalogForm,
      hideForm: hideServiceCatalogFormForm
    };
  });

  useEffect(() => {
    const eventIndex = EventEmitterWithIndex.subscribe(
      'OpenServiceCatalogForm',
      showServiceCatalogForm
    );
    return () => {
      EventEmitterWithIndex.unsubscribe('OpenServiceCatalogForm', eventIndex);
    };
  }, []);

  return (
    <CustomModal
      open={showForm}
      onClose={hideServiceCatalogFormForm}
      locked
      zIndex={999}
    >
      <div className={className ?? 'bg-white br10 w-80vw height-70vh'}>
        <UserGuide>
          <ServiceCatalogForm
            {...serviceCatalogFormDataRef.current}
            hideAddNew={hideAddNew}
            closeForm={hideServiceCatalogFormForm}
            createServiceItem={saveServiceCatalogItem('CREATE')}
            updateServiceItem={saveServiceCatalogItem('UPDATE')}
          />
        </UserGuide>
      </div>
    </CustomModal>
  );
};

export default ServiceCatalogModal;
